<template>
    <div class="user-index__check-box" v-show="isAdmin">
        <checkbox
            v-show="isAdmin"
            class="h:margin-bottom-8"
            value="1"
            v-model="show_deleted_users"
            @change="fetch()">
           {{ trans('managers.label.deleted_users') }}
        </checkbox>
    </div>
</template>

<script>
    import { EventBus } from '../eventbus';

    export default {
        data() {
            return {
                show_deleted_users: false,
                isAdmin: false,
            }
        },

        mounted() {
            EventBus.$on('filterDataChanged', data => {
                this.isAdmin = data.isAdmin;
            });
        },

        methods: {
            fetch() {
                EventBus.$emit('filterDeletedUser', this.show_deleted_users);
            }
        }

    }
</script>
